const DividerIconForLogin = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="596"
        height="2"
        viewBox="0 0 596 2"
        fill="none"
      >
        <path d="M0 1L596 0.999948" stroke="#0C3688" strokeOpacity="0.2" />
      </svg>
  );
};
export default DividerIconForLogin;
